import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";
import { LABEL_UsernameValid } from "../Utils/Strings/Labels";
import { checkUserLanguage } from "../Utils/Check_Value";

const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

const initialState = {
    isFetching                : false,
    operatoriList             : [],
    holdingList               : [],
    aziendeList               : [],
    errorMessage              : null,
    showAddOperatoreDialog    : false,
    errorAddOperatoreUsername : null, 
    errorAddOperatoreEmail    : null,
    usernameAssociaError      : null,
    paypalConfig     : {
                            Environment : 'sandbox', // you can set here to 'production' for production
                            Client      : { sandbox: "Ac_XSSAkfV9jHSgAWpeAKzcKbRaIDmdr7n4MhADXyIBX5nrYI7LNEjKYBQEbquK03zxG7UkUzRVE5yre", production: "APP-80W284485P519543T" }
                        },
    paypalPrice      : {}
};

const operatoreReducer = (state = initialState, action) => {
    switch (action.type){
        case actionType.SHOW_LOADER:
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_OPERATORI_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_OPERATORI_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                operatoriList    : typeof action.response === 'undefined' ? [] : action.response,
                authenticated : action.authenticated || false
            })
        case actionType.SERVICE_OPERATORI_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        case actionType.SERVICE_OPERATORI_REFRESH_LIST :
            return Object.assign({}, state, {
                isFetching : false,
                operatoriList : action.newList
            })
        //LISTA HOLDING
        case actionType.SERVICE_HOLDING_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_HOLDING_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                holdingList   : typeof action.response === 'undefined' ? [] : action.response,
                authenticated : action.authenticated || false
            })
        case actionType.SERVICE_HOLDING_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //LISTA AZIENDE
        case actionType.SERVICE_AZIENDE_TUPLA_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_AZIENDE_TUPLA_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                aziendeList   : typeof action.response === 'undefined' ? [] : action.response,
                authenticated : action.authenticated || false
            })
        case actionType.SERVICE_AZIENDE_TUPLA_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //ADD UTENTE
        case actionType.SERVICE_OPERATORI_OPEN_ADD_DIALOG :
            return Object.assign({}, state, {
                showAddOperatoreDialog : true,
                errorAddOperatoreUsername : null,
                errorAddOperatoreEmail : null
            })
        case actionType.SERVICE_OPERATORI_CLOSE_ADD_DIALOG :
            return Object.assign({}, state, {
                isFetching : false,
                showAddOperatoreDialog : false
            })
        case actionType.SERVICE_OPERATORI_ADD_REQUEST :
            return Object.assign({}, state, {
                isFetching : true,
                showAddOperatoreDialog : true,
                errorAddOperatoreUsername : null,
                errorAddOperatoreEmail : null
            })
        case actionType.SERVICE_OPERATORI_ADD_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                aziendeList   : typeof action.response === 'undefined' ? [] : action.response,
                authenticated : action.authenticated || false,
                showAddOperatoreDialog : false,
                errorAddOperatoreUsername : null,
                errorAddOperatoreEmail : null
            })
        case actionType.SERVICE_OPERATORI_ADD_ERROR :
            var error = action.error.split(";");
            var errorUsername, errorEmail = null;
            errorUsername = errorEmail = null;
            for (var i = 0; i < error.length; i++) {
              var trim = error[i].trim();
              if (trim.includes("Il nome")) errorUsername = trim;
              if (trim.includes("L'indirizzo di posta elettronica ")) errorEmail = trim;
            }
            return Object.assign({}, state, {
                isFetching                : false,
                showAddOperatoreDialog    : true, 
                errorAddOperatoreUsername : errorUsername,
                errorAddOperatoreEmail    : errorEmail
            })
        //RECUPERO I DATI DELL'UTENTE
        case actionType.SERVICE_USERINFO_REQUEST :
        return Object.assign({}, state, {
            isFetching : true,
        })
        case actionType.SERVICE_USERINFO_SUCCESS :
        var response = action.response;
        //salvo i dati dell'utente
        if(response.hasOwnProperty("IDUser") && response.hasOwnProperty("Username") && response.hasOwnProperty("Role")){
            localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(response));
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : action.authenticated || false,
            userInfo        : response
            })
        }else{
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : false,
            userInfo        : null
            })
        }
        case actionType.SERVICE_USERINFO_ERROR :
        return Object.assign({}, state, {
            isFetching: false,
            errorMessage: action.error || null,
            isAuthenticated: false
        });
        
        //PAYPAL CONFIG
        case actionType.SERVICE_PAYMENT_CONFIG_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_PAYMENT_CONFIG_SUCCESS :
            return Object.assign({}, state, {
                errorMessage : null,
                paypalConfig : action.config
            })
        case actionType.SERVICE_PAYMENT_CONFIG_ERROR :
            return Object.assign({}, state, {
                errorMessage : action.msgError
            })
        //PAYPAL PRICES
        case actionType.SERVICE_PAYMENT_PRICES_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_PAYMENT_PRICES_SUCCESS :
            return Object.assign({}, state, {
                errorMessage : null,
                paypalPrice  : action.prices[1] || {}
            })
        case actionType.SERVICE_PAYMENT_PRICES_ERROR :
            return Object.assign({}, state, {
                errorMessage : action.msgError
            })
        //operatore
        case actionType.SERVICE_CHECK_USERNAME_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_CHECK_USERNAME_SUCCESS :
            return Object.assign({}, state, {
                usernameError : null
            })
        case actionType.SERVICE_CHECK_USERNAME_ERROR :
            return Object.assign({}, state, {
                usernameError : action.error,
                usernameAssociaError : action.error === "Username Gia' Utilizzato" ? LABEL_UsernameValid[USERLANGUAGE] : null
            })
        case actionType.SERVICE_CHECK_EMAIL_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_CHECK_EMAIL_SUCCESS :
            return Object.assign({}, state, {
                userEmailError : null
            })
        case actionType.SERVICE_CHECK_EMAIL_ERROR :
            return Object.assign({}, state, {
                userEmailError : action.error
            })
        default:
            return state;
    }
};

export default operatoreReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Operatore.js